export default __webpack_public_path__ + "static/media/new.fe1c3e05.svg";